import React, { Component } from 'react';
import '../assets/css/home/notfound.css'
class NotFound extends Component {
    render() {
        return (
            <div className='notfound'>
                <img src="https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fwww.netcyw.cn%2Fvc%2Fpics%2F20210617140818-01.jpg&refer=http%3A%2F%2Fwww.netcyw.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1674716231&t=d3efbc942ea06aa72dd7fb77f36f81ce" alt="" />
            </div>
        );
    }
}

export default NotFound;
<style>
.notfound img{
        
    }
</style>